<template>
  <nav class="navbar is-transparent">
    <div class="navbar-brand p-sm">
      <div class="navbar-item">
        <div v-if="schoolPage() && school">
          <a
            :href="school.url"
            target="_blank"
          >
            <img
              :src="'/img/logos/'+ schoolLogo()"
              class="school-logo"
            >
          </a>
        </div>
        <div class="navbar-item is-hidden-mobile">
          <div class="app-title is-small">
            <span class="diderot">Diderot</span><strong class="max">Max</strong>
          </div>
        </div>
      </div>
      <div
        v-if="$route.meta.hasMenu !== false"
        class="navbar-burger burger"
        data-target="navMenu"
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </div>
    </div>

    <div
      v-if="$route.meta.hasMenu !== false"
      id="navMenu"
      class="navbar-menu"
    >
      <div
        v-if="$route.meta.schoolType === 'highschool'"
        class="navbar-end"
      >
        <router-link
          v-if="isLoggedIn"
          class="navbar-item"
          :to="{ name: 'profile'}"
        >
          <span>{{ $t('candidate.general.application') }}</span>
        </router-link>
        <router-link
          class="navbar-item"
          :to="{ name: 'highschool-categories'}"
        >
          <span>{{ $t('menu.general.highschool_internship') }}</span>
        </router-link>
        <router-link
          v-if="isLoggedIn"
          class="navbar-item"
          :to="{ name: 'highschool-profile'}"
        >
          <span>{{ $t('menu.general.account') }}</span>
        </router-link>
        <a
          v-if="isLoggedIn"
          href="#"
          class="navbar-item app-disconnect"
          @click="logoutUser"
        >
          <i
            class="fa fa-power-off"
            aria-hidden="true"
          />
        </a>
      </div>

      <div
        v-if="$route.meta.schoolType === 'eschool'"
        class="navbar-end"
      >
        <router-link
          v-if="isLoggedIn"
          class="navbar-item"
          :to="{ name: 'eschool-application'}"
        >
          <span>{{ $t('candidate.eschool.application') }}</span>
        </router-link>
        <router-link
          class="navbar-item"
          :to="{ name: 'eshop-categories'}"
        >
          <span>{{ $t('candidate.eschool.sessions') }}</span>
        </router-link>
        <router-link
          v-if="isLoggedIn"
          class="navbar-item"
          :to="{ name: 'eschool-profile'}"
        >
          <span>{{ $t('menu.general.account') }}</span>
        </router-link>
        <a
          v-if="isLoggedIn"
          href="#"
          class="navbar-item app-disconnect"
          @click="logoutUser"
        >
          <i
            class="fa fa-power-off"
            aria-hidden="true"
          />
        </a>
      </div>

      <div
        v-if="$route.meta.schoolType === 'boardingschool'"
        class="navbar-end"
      >
        <router-link
          class="navbar-item app-contact"
          :to="{ name: 'shop-categories', hash: '#contact-form'}"
        >
          <b-tooltip
            :label="$t('contact.form.title')"
            position="is-bottom"
            animated
          >
            <i
              class="fa fa-envelope-o"
              aria-hidden="true"
            />
          </b-tooltip>
        </router-link>

        <router-link
          v-if="isLoggedIn && hasCandidates"
          class="navbar-item"
          :to="{ name: 'school-application', params: { school: $route.params.school }}"
        >
          <span>{{ $t('menu.general.candidates') }}</span>
        </router-link>

        <router-link
          v-if="isLoggedIn && hasCandidates && hasSchoolingCandidates"
          class="navbar-item"
          :to="{ name: 'shop-categories'}"
        >
          <span>{{ $t('menu.general.offers') }}</span>
        </router-link>

        <router-link
          class="navbar-item"
          :to="{ name: 'shop-internship'}"
        >
          <span>{{ $t('menu.general.internship') }}</span>
        </router-link>

        <router-link
          v-if="isLoggedIn"
          class="navbar-item"
          :to="{ name: 'school-profile'}"
        >
          <span>{{ $t('menu.general.account') }}</span>
        </router-link>
        <router-link
          v-if="!isLoggedIn && $route.name !== 'connection-shop'"
          :to="{ name: 'connection-shop'}"
          class="navbar-item"
          replace
        >
          <span>{{ $t('menu.general.connection') }}</span>
        </router-link>
        <a
          v-if="isLoggedIn"
          href="#"
          class="navbar-item app-disconnect"
          @click="logoutUser"
        ><i
          class="fa fa-power-off"
          aria-hidden="true"
        />
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import Api from 'services/organization'
import {mapActions, mapGetters} from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(
        'auth', [
          'isLoggedIn'
        ]
    ),
    ...mapGetters(
        'candidate', [
          'hasCandidates',
          'hasSchoolingCandidates'
        ]
    ),
    ...mapGetters(
        'organization', [
          'getSchoolBySlug'
        ]
    ),
    ...mapGetters(
        'orders', [
          'isSchoolingOrder'
        ]
    ),
    school() {
      return this.getSchoolBySlug(this.$route.params.school)
    }
  },
  methods: {
    ...mapActions({
      logout: 'auth/logout'
    }),
    logoutUser() {
      if (this.$route.meta.schoolType === 'highschool') {
        this.logout().then(response => {
          this.$router.replace({name: 'highschool-connection', params: {school: this.$route.params.school}})
        }, error => {
        })
      }

      if (this.$route.meta.schoolType === 'eschool') {
        this.logout().then(response => {
          this.$router.replace({name: 'eschool-connection', params: {school: this.$route.params.school}})
        }, error => {
        })
      }

      if (this.$route.meta.schoolType === 'boardingschool') {
        this.logout().then(response => {
          this.$router.replace({name: 'school-connection', params: {school: this.$route.params.school}})
        }, error => {
        })
      }

    },
    schoolLogo() {
      if (this.$route.params.school && this.$route.params.name !== 'not-found') {
        return this.$route.params.school + '.png'
      } else {
        return 'diderot.png'
      }
    },
    schoolPage() {
      return this.$route.params.school
    }
  },
  mounted() {
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

      // Add a click event on each of them
      $navbarBurgers.forEach(el => {
        el.addEventListener('click', () => {

          // Get the target from the "data-target" attribute
          const target = el.dataset.target;
          const $target = document.getElementById(target);

          // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
          el.classList.toggle('is-active');
          $target.classList.toggle('is-active');

        });
      });
    }
  }

}
</script>

<style lang="scss" scoped>


.navbar {
  border-bottom: 1px solid #dedede;
}

.navbar-item {
  font-weight: 500;
}

.navbar-item:hover {
  text-decoration: none;
}

.app-title {
  font-weight: normal;
  font-size: 0.7em;

  &:hover {
    text-decoration: none;
  }
}

.diderot {
  font-size: 2.6em;
  margin-left: 10px;
  color: #051527;
}

.school-logo {
  max-height: 4.5rem;
  margin-bottom: -1.5rem;
  margin-top: -1.5rem;
}


.white-logo {
  visibility: hidden;
}

.max {
  font-size: 2.6em;
  color: #28374B;
}

a.navbar-item.is-active {
  padding-bottom: 0;
  border-bottom: 5px solid #0f1e44;
}


</style>
